export default {
    install(Vue) {
        Vue.mixin({
            methods: {
                strToInt(str) {
                    return str === '' || str === null ? null : parseInt(str);
                },
                strToFloat(str) {
                    return str === '' || str === null ? null : parseFloat(str);
                },
                strToStr(str) {
                    return str === '' || str === null ? null : str;
                },
                intToInt(v) {
                    return v !== undefined ? v : null;
                },
                anyToStr(v) {
                    if (typeof v === 'string') return v;
                    return '';
                }
            }
        })
    }
}